import {Dispatch} from 'redux';
import {
  MATCHINFO_BY_ID_GET_INVALIDATE,
  MATCHINFO_BY_ID_GET_REQUEST,
  MATCHINFO_BY_ID_GET_RESPONSE,
} from '../../actionTypes';
import {
  MatchInfoByIdGetInvalidateAction,
  MatchInfoByIdGetRequestAction,
  MatchInfoByIdGetResponseAction,
} from '../types';
import {sportEventInfoById} from '../../../API/sportEvents';
import {MatchInfo} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {beMatchInfoToMatchInfo} from '../../../API/utils';

/**
 * Action creator for the get request of the single match info request (by id)
 * @param id
 */
const getMatchInfoByIdGetRequest = (id: string): MatchInfoByIdGetRequestAction => ({
  type: MATCHINFO_BY_ID_GET_REQUEST,
  payload: id,
});

/**
 * Action creator for the get response of the single match info request (by id)
 */
const getMatchInfoByIdGetResponse = (match: MatchInfo): MatchInfoByIdGetResponseAction => ({
  type: MATCHINFO_BY_ID_GET_RESPONSE,
  payload: {match},
});

/**
 * Action creator for the get invalidation of the single match info request (by id)
 * @param error
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getMatchInfoByIdGetInvalidate = (error: Error): MatchInfoByIdGetInvalidateAction => ({
  type: MATCHINFO_BY_ID_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // TODO: document
 */
const getMatchInfoById = (id: string) => (dispatch: Dispatch): Promise<any> => {
  dispatch(getMatchInfoByIdGetRequest(id));

  return sportEventInfoById(id)
    .then(beMatchInfoToMatchInfo)
    .then((match: MatchInfo) => dispatch(getMatchInfoByIdGetResponse(match)))
    .catch((error: Error) => dispatch(getMatchInfoByIdGetInvalidate(error)));
};

export default getMatchInfoById;
